import i18n from "@/plugins/i18n";
import SelectItem from "@/models/components/inputs/selectItem";
import { filterCapitalize } from "@/filters/capitalize";

export enum REQUEST_FOR_PAYMENT_DOCUMENT_TYPES {
  requestsForPayment = 1,
  preTrialRequestForPayment = 2,
  interestNote = 3,
}

export const requestForPaymentDocumentTypes = () =>
  [
    {
      value: REQUEST_FOR_PAYMENT_DOCUMENT_TYPES.requestsForPayment,
      text: filterCapitalize(i18n.t("requestsForPayment")),
    } as SelectItem,
    {
      value: REQUEST_FOR_PAYMENT_DOCUMENT_TYPES.preTrialRequestForPayment,
      text: filterCapitalize(i18n.t("preTrialRequestForPayment")),
    } as SelectItem,
    {
      value: REQUEST_FOR_PAYMENT_DOCUMENT_TYPES.interestNote,
      text: filterCapitalize(i18n.t("interestNote")),
    } as SelectItem,
  ] as Array<SelectItem>;
